import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportterminaltopunecab() {



const cardData = {
  keyword: "  Mumbai Airport Terminal to Pune Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport Terminal to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai Airport Terminal to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport Terminal to Pune cab travel.",

topPlaces: [
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring top international brands, dining options, multiplex cinemas, and entertainment zones. Travelers booking a sedan cab in Pune can enjoy a complete leisure experience with shopping, food, and movies in one place."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic hilltop destination offering panoramic views of Pune city. Visitors can climb the stone steps to explore ancient temples and enjoy a peaceful atmosphere with scenic sunrise and sunset views."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic waterfront location near Pune known for its calm lake views and refreshing environment. It is a popular spot for evening outings, photography, and relaxing drives by sedan cab."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is an iconic fort in Pune that showcases the grandeur of the Maratha Empire. Visitors can explore its historic gates, ruins, and enjoy the captivating evening light and sound show."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a peaceful riverside park in Pune offering greenery, walking paths, and boating activities. It is ideal for relaxation, family outings, and evening walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant heritage site linked to India’s freedom struggle. It features elegant architecture, peaceful gardens, and a museum dedicated to Mahatma Gandhi."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden with serene landscapes, ponds, and walking paths. It is perfect for relaxation and photography."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its greenery and the famous Siddhivinayak Temple. It is a favorite destination for families and morning walkers."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a vast collection of Indian artifacts, sculptures, and musical instruments, offering deep insights into India’s cultural heritage."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. It is known for its spiritual atmosphere and historic significance."
  }
],



services: [
{
name: "Mumbai Airport Terminal 1 to Pune Cab Fare",
description: "Mumbai Airport Terminal 1 to Pune cab service provides convenient and reliable transportation for travelers arriving at the domestic airport. Passengers can easily book comfortable vehicles such as sedan, Ertiga, and Innova Crysta for a smooth journey from Terminal 1 to Pune. Professional drivers monitor flight schedules and ensure timely pickups outside the arrival gate. The journey via the Mumbai–Pune Expressway offers fast and comfortable highway travel. This service is ideal for business travelers, families, and tourists heading to Pune after landing in Mumbai. Air-conditioned vehicles, luggage space, and experienced drivers make the trip safe and relaxing. Transparent cab fare options allow passengers to plan their travel budget easily."
},
{
name: "Mumbai Airport Terminal 2 to Pune Cab",
description: "Mumbai Airport Terminal 2 to Pune cab service offers premium airport transfer for passengers arriving at Chhatrapati Shivaji Maharaj International Airport. Travelers can book sedan, Ertiga, or Innova vehicles depending on their comfort and group size. Professional drivers provide punctual pickups from the arrival gate and assist with luggage handling. This cab service ensures smooth expressway travel between Mumbai and Pune with comfortable seating and air-conditioned vehicles. It is widely used by corporate travelers, families, and international tourists traveling to Pune city."
},
{
name: "Mumbai Airport Terminal 3 to Pune Cab",
description: "Mumbai Airport Terminal 3 to Pune cab service offers dependable airport transportation for travelers arriving in Mumbai and continuing their journey to Pune. Comfortable vehicles such as sedan, Ertiga, and Innova provide smooth long-distance travel through the Mumbai–Pune Expressway. Professional drivers ensure safe driving and punctual pickups from airport terminals. Travelers benefit from spacious vehicles, luggage support, and reliable service during the journey."
},
{
name: "Mumbai Domestic Airport Terminal 1 to Pune Cab",
description: "Mumbai domestic airport Terminal 1 to Pune cab service offers convenient transportation for passengers landing at Mumbai’s domestic terminal. Travelers can easily book taxis to Pune with comfortable vehicles and professional drivers. This service is widely used by corporate travelers, students, and families arriving in Mumbai. Air-conditioned vehicles ensure comfortable travel during the long highway journey."
},
{
name: "Mumbai Domestic Airport Cab",
description: "Mumbai domestic airport cab service provides reliable transportation for passengers traveling from Mumbai airport to nearby cities including Pune. Travelers can choose vehicles such as sedan, Ertiga, and Innova depending on comfort preferences. Professional drivers provide punctual pickup and safe driving throughout the journey."
},
{
name: "Mumbai International Airport Taxi",
description: "Mumbai international airport taxi service provides convenient transportation for passengers arriving from international destinations. Travelers can easily book taxis for travel to Pune and other nearby cities. Comfortable vehicles, experienced drivers, and smooth expressway travel ensure safe and relaxing long-distance journeys."
},
{
name: "24x7 Mumbai Airport Cab Booking",
description: "24x7 Mumbai airport cab booking service allows travelers to reserve taxis anytime for airport transfers and outstation trips to Pune. Passengers can book vehicles online and receive instant confirmation for their journey. Professional drivers remain available around the clock to ensure timely pickups regardless of flight arrival time."
},
{
name: "Mumbai Airport Outstation Taxi",
description: "Mumbai airport outstation taxi service provides long-distance transportation from Mumbai airport to cities such as Pune, Nashik, Lonavala, and Shirdi. Travelers can choose comfortable vehicles such as sedan, Ertiga, and Innova for safe highway travel. This service is ideal for business trips, family travel, and tourism."
},
{
name: "Mumbai Airport Innova Cabs",
description: "Mumbai airport Innova cab service offers premium SUV transportation for travelers seeking extra comfort and luggage space. The Toyota Innova provides spacious seating and smooth highway performance, making it perfect for long journeys to Pune. Professional drivers ensure safe driving and punctual airport pickups."
},
{
name: "Mumbai Airport Ertiga Taxi",
description: "Mumbai airport Ertiga taxi service offers spacious 7-seater SUV transportation for families and small groups traveling from the airport to Pune. The Ertiga provides comfortable seating and air-conditioned travel for long-distance journeys. Professional drivers provide safe driving and reliable airport pickup service."
},
{
name: "Mumbai Airport Sedan Cab Service",
description: "Mumbai airport sedan cab service offers economical travel options using vehicles such as Swift Dzire, Etios, and Xcent. These vehicles are ideal for individual travelers and couples traveling from Mumbai airport to Pune. Comfortable seating and professional drivers ensure safe highway travel."
},
{
name: "Mumbai Airport Terminal 2 Taxi Service",
description: "Mumbai airport Terminal 2 taxi service provides reliable transportation for passengers arriving at the international terminal. Travelers can easily book taxis for travel to Pune with professional drivers waiting outside the arrival area. Comfortable vehicles ensure smooth expressway travel between Mumbai and Pune."
},
{
name: "Transport Facility at Mumbai Airport",
description: "Transport facility at Mumbai Airport includes reliable taxi services, private cabs, and outstation vehicles for travelers heading to cities such as Pune. Passengers can conveniently book transportation from airport terminals with professional drivers providing safe and comfortable travel."
},
{
name: "Book Airport Services Online",
description: "Book airport services online to arrange convenient taxi transportation from Mumbai Airport to Pune and nearby destinations. Online booking platforms allow passengers to select vehicles, check fare details, and confirm rides instantly for smooth airport transfers."
},
{
name: "Book Airport Services Online India",
description: "Book airport services online in India to arrange convenient taxi transfers from major airports including Mumbai Airport. Travelers can easily book vehicles for long-distance travel to cities such as Pune with instant booking confirmation."
},
{
name: "Book Mumbai Airport Services Online",
description: "Book Mumbai airport services online to schedule reliable taxi transportation directly from airport terminals. Travelers can reserve comfortable vehicles such as sedan, Ertiga, or Innova for safe travel to Pune and nearby destinations."
},
{
name: "Book Mumbai Airport Services Online Terminal 1",
description: "Book Mumbai airport services online for Terminal 1 to ensure convenient pickup immediately after arrival. Travelers can pre-book taxis to Pune and other cities with professional drivers waiting at the airport pickup area."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport to Pune cab service provides reliable transportation for passengers traveling between the airport and Pune city. Comfortable vehicles and experienced drivers ensure smooth highway travel through the Mumbai–Pune Expressway."
},
{
name: "Mumbai Airport to Pune Taxi",
description: "Mumbai Airport to Pune taxi service offers convenient airport transfers with comfortable vehicles and professional drivers ensuring safe long-distance journeys."
},
{
name: "Mumbai Airport to Pune Cab Service",
description: "Mumbai Airport to Pune cab service offers dependable transportation with comfortable vehicles and experienced drivers ensuring safe and convenient travel."
},
{
name: "Mumbai Airport to Pune One Way Cab",
description: "Mumbai Airport to Pune one way cab service offers economical travel for passengers who require a single-direction trip between Mumbai Airport and Pune."
}
],

tableData: [
["Mumbai Airport Terminal 1 to Pune Cab Fare","Mumbai Airport Terminal 2 to Pune Cab"],
["Mumbai Airport Terminal 3 to Pune Cab","Mumbai Domestic Airport Terminal 1 to Pune Cab"],
["Mumbai Domestic Airport Cab","Mumbai International Airport Taxi"],
["24x7 Mumbai Airport Cab Booking","Mumbai Airport Outstation Taxi"],
["Mumbai Airport Innova Cabs","Mumbai Airport Ertiga Taxi"],
["Mumbai Airport Sedan Cab Service","Mumbai Airport Terminal 2 Taxi Service"],
["Transport Facility at Mumbai Airport","Book Airport Services Online"],
["Book Airport Services Online India","Book Mumbai Airport Services Online"],
["Book Mumbai Airport Services Online Terminal 1","Mumbai Airport to Pune Cab"],
["Mumbai Airport to Pune Taxi","Mumbai Airport to Pune Cab Service"],
["Mumbai Airport to Pune One Way Cab","Mumbai Airport to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently operate Mumbai Airport Terminal to Pune cab services. Their familiarity with airport pickup zones, terminals, and the Mumbai Pune Expressway ensures smooth and timely airport transfers."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai Airport Terminal to Pune cab bookings. Customers receive clear fare details including toll charges, parking fees, and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport Terminal to Pune cab service operates 24 hours a day. Whether your flight lands early morning or late night, Velocity Cabs ensures reliable airport transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience from Mumbai Airport to Pune."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way airport drop, round-trip bookings, and customized airport transfer plans from Mumbai Airport Terminal to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Direct Pickup From Airport Terminals",
    WhyChoosedescription: "We provide convenient pickup from Mumbai Airport terminals including Terminal 1 and Terminal 2 with professional drivers waiting at designated pickup points."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport Terminal to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport Terminal to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport Terminal to Pune with professional drivers and comfortable vehicles." },
  { question: "Which Mumbai Airport terminals do you provide pickup from?", answer: "Velocity Cabs provides pickup from both Mumbai Airport Terminal 1 and Terminal 2." },
  { question: "How far is Mumbai Airport from Pune?", answer: "The road distance between Mumbai Airport and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mumbai Airport to Pune cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Which vehicles are available for Mumbai Airport to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai Airport to Pune?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai Airport to Pune." },
  { question: "Do drivers wait at the airport for pickup?", answer: "Yes, our drivers wait at the airport arrival pickup area to ensure smooth passenger pickup." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport Terminal to Pune cab services online or through phone booking." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "After landing at Mumbai Airport Terminal, the transfer to Pune was handled very smoothly. The cab was comfortable, and the journey felt well-coordinated and stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "The ride from Mumbai Airport Terminal to Pune was very convenient. The pickup was quick, the vehicle was clean, and the long journey was completed comfortably.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab Service | Velocity Cabs",
  "description": "Book cab from Mumbai Airport (Terminals 1, 2, 3) to Pune with Velocity Cabs. 24x7 taxi service including Innova, Innova Crysta, Ertiga, and Sedan. One-way, round trip, and outstation airport transfers available.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Mumbai Airport to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta
    name="description"
    content="Book Mumbai Airport (Terminal 1, 2, 3) to Pune cab with Velocity Cabs. 24x7 airport transfer cabs including Innova, Innova Crysta, Ertiga & Sedan. One-way & round trip options available."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportterminaltopunecab;